var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview" }, [
    _c("div", { attrs: { id: "contents" } }, [
      _c("div", { staticClass: "inner clearfix detail-top" }, [
        _vm.companyInfo.name
          ? _c(
              "h1",
              {
                staticClass: "mt10 fll hd-type-01 company-name",
                attrs: { "data-test": "company-name" },
              },
              [_vm._v("\n        " + _vm._s(_vm.companyInfo.name) + "\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "contents-inner clearfix" }, [
          _c(
            "section",
            { staticClass: "mt10" },
            [
              _c(
                "article",
                [
                  !_vm.isLightPlan
                    ? _c("job-preview-company-introduction", {
                        attrs: {
                          "catch-copy": _vm.companyInfo.catchCopy,
                          text: _vm.companyInfo.introText,
                          image: _vm.companyInfo.introImage,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "details clearfix" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-right -active" }, [
                      _c("ul", { staticClass: "list-style-01" }, [
                        _c(
                          "li",
                          {
                            staticClass: "mb10",
                            style:
                              "background: url(" +
                              _vm.userCommonImageUrlForPc +
                              "/icn_arrow_01.png) no-repeat center left;",
                            attrs: { "data-test": "recruitment-job-info-text" },
                          },
                          [
                            _c(
                              "a",
                              { staticClass: "recruitment-job-info-text" },
                              [
                                _vm._v(
                                  "募集中の求人情報の「職種名」が表示されます。"
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("job-preview-content-outline", {
                    attrs: {
                      title: "事業内容",
                      value: _vm.companyInfo.businessContent,
                      "data-test": "businessContent",
                    },
                  }),
                  _vm._v(" "),
                  _vm.companyInfo.established
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "設立",
                          value: _vm.companyInfo.established,
                          "data-test": "established",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.companyInfo.capital
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "資本金",
                          value: _vm.companyInfo.capital,
                          "data-test": "capital",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.companyInfo.sale
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "売上高",
                          value: _vm.companyInfo.sale,
                          "data-test": "sale",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShow.employee
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "従業員数",
                          value: _vm.companyInfo.employeeNumber,
                          "data-test": "employeeNumber",
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.companyInfo.averageAge ||
                            _vm.companyInfo.midCareerPercentage
                              ? {
                                  key: "sub",
                                  fn: function () {
                                    return [
                                      _vm.companyInfo.averageAge
                                        ? _c("job-preview-content-sub", {
                                            attrs: {
                                              title: "平均年齢",
                                              value: _vm.companyInfo.averageAge,
                                              "title-class": "fwb",
                                              "data-test": "averageAge",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.companyInfo.midCareerPercentage
                                        ? _c("job-preview-content-sub", {
                                            attrs: {
                                              title: "中途入社者の割合",
                                              value:
                                                _vm.companyInfo
                                                  .midCareerPercentage,
                                              "title-class": "fwb",
                                              "data-test":
                                                "midCareerPercentage",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShow.representative
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "代表者",
                          value: _vm.companyInfo.representative,
                          "data-test": "representative",
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.companyInfo.representativeProfile
                              ? {
                                  key: "sub",
                                  fn: function () {
                                    return [
                                      _c("job-preview-content-sub", {
                                        attrs: {
                                          title: "代表者略歴",
                                          value:
                                            _vm.companyInfo
                                              .representativeProfile,
                                          "title-class": "fwb",
                                          "data-test": "representativeProfile",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.companyInfo.note
                    ? _c("job-preview-content-outline", {
                        attrs: {
                          title: "備考",
                          value: _vm.companyInfo.note,
                          "data-test": "note",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.companyInfo.hp
                    ? _c(
                        "job-preview-content-outline",
                        { attrs: { title: "企業HP", "data-test": "hp" } },
                        [
                          _c("job-preview-content", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "body",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "clearfix" }, [
                                        _c("a", {
                                          attrs: {
                                            href: _vm.companyInfo.hp,
                                            rel: "nofollow",
                                            target: "blank",
                                            "data-test": "value",
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.companyInfo.hp
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              148559646
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isLightPlan
                ? _c("job-preview-company-images", {
                    attrs: { "company-info": _vm.companyInfo },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("section", { staticClass: "mt20 mb20" }, [
            !_vm.isLightPlan && _vm.report.body
              ? _c(
                  "div",
                  {
                    staticClass: "viewpoints pt25 pb25 plr20",
                    attrs: { "data-test": "viewpoints" },
                  },
                  [
                    _c("div", { staticClass: "viewpoints-left tc pr25" }, [
                      _c("img", {
                        staticClass: "mb5 viewpoints-img",
                        attrs: {
                          src: _vm.userCommonImageUrlForPc + "/viewpoints.png",
                          alt: "viewpoints",
                          "data-test": "viewpoints-img",
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(2),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "viewpoints-right pl25" }, [
                      _vm.report.name
                        ? _c("span", {
                            staticClass: "tl fwB fs13 block-style",
                            attrs: { "data-test": "viewpoints-name" },
                            domProps: {
                              textContent: _vm._s(
                                "取材担当" + _vm.report.name + "より"
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "tl fs13 block-style pega-pre-wrap",
                        attrs: { "data-test": "viewpoints-body" },
                        domProps: { textContent: _vm._s(_vm.report.body) },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isShowEnvironment(_vm.environment)
            ? _c(
                "div",
                {
                  staticClass: "company-preview",
                  attrs: { "data-test": "environmentForCompany" },
                },
                [
                  _c(
                    "section",
                    { staticClass: "mt20 mb20" },
                    [
                      _c("job-preview-data-for-company", {
                        attrs: { environment: _vm.environment },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "mt30 fs13 detail-menu" }, [
      _c("li", { staticClass: "active" }, [
        _vm._v("\n          募集情報\n        "),
      ]),
      _vm._v(" "),
      _c("a", [_c("li", [_vm._v("フォトクリップ")])]),
      _vm._v(" "),
      _c("a", [_c("li", [_vm._v("インタビュー記事")])]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left -active" }, [
      _c("h2", { staticClass: "fwb" }, [
        _vm._v("\n                  募集中の求人情報\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "fs13 fwB" }, [
      _vm._v("\n                女の転職！"),
      _c("br"),
      _vm._v("取材レポート\n              "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }